//Leads: DEPRECATED, REMOVE IN FUTURE
export class Leads {
    quoteId: number
    clientname: string
    customername: string
    customercell: string
    channel: string
    state: string
    description: string
    dt: string 
    customerId: number
    salesman: string
    expiryhours: number
}


export class LeadsChart {
    labels: string[]
    national: number[]
    centre: number[]
    channels: string[]
}

export class Lead {
    quoteId: number;
    customerId: number; 
    customerName: string;
    customerCell: string;
    customerEmail: string;
    sellerId: number;
    buyerId: number;
    buyerName: string;
    quoteActionStatus: string | null;
    stateId: number;
    statusId: number;
    statusDescription: string;
    dtCreated: Date;
    dtAction: Date;
    actionInMinutes: number;
    expiryInHours: number;
    bookingDate: string;
    assignedTo: string;
    userId: number;
    leadChannel: string;
    comment: string [];
    specialPriceSetName: string;
    customerOrderReference: string;
}

export class LeadQuote extends Lead {
    runningTotal: number;
    stateType: number;
    
}

export class WIPLeadItem {
    quoteId: number;
    msfid: number;
    stockCode: string;
    description: string;
    qty: number;
    brandImage: string;
    brand: string;
    soh: number;
}

export class WIPLead {
    quoteId: number;
    quoteRef: string;
    // customerId: number; 
    customerName: string;
    customerCell: string;
    sellerId: number;
    buyerId: number;
    buyerName: string;
    // stateId: number;
    statusId: number;
    // statusDescription: string;
    dtCreated: Date;
    dtAction: Date;
    actionInMinutes: number;
    assignedTo: string;
    userId: number;
    total: number;
    totalIncl: number;
    vehicle_Reg: string;
    vehicle_Make: string;
    vehicle_Model: string;
    items: WIPLeadItem[];
    customerOrderReference: string;
    stockPicked: number = 0; // Default stock picked value
    isPickable: boolean = true;
}

export class WIPSummaryItemLead {
    quoteId: number;
    quoteRef: string;
    customerName: string;
    msfid: number;
    qty: number;
    statusId: number;
}

export class WIPSummaryItem {
    msfid: number;
    stockCode: string;
    description: string;
    brandImage: string;
    brand: string;
    qtyReserverd: number;
    qtyNotReserved: number;
    leads: WIPSummaryItemLead[];
    soh: number;
}


export class Comments {
    date: string;
    comment: string;
}

export class StockPicked {
    orderId: number;
    orderLineId: number;
    SFReference: string;
    quoteId: number;
    quoteLineId: number;
    msfId: number;
    stockCode: string;
    description: string;
    qty: number;
    pickedQty: number;
    brandImage: string;
    brand: string;
    soh: number;
    availableSOH: number = 0;
    statusId: number = 0; // Default status
    comments: string = '';
    isTyre: boolean = false;
    isPickable: boolean = true;
    userId: number = 0; // Default user ID
    assignedTo: string = '';
    dt: Date = new Date();
    customerName: string = '';
    vehicleReg: string = '';
    vehicleMake: string = '';
    vehicleModel: string = '';
    stockPicked: number = 0; // Default stock picked value
    jobCardNumber: string = '-';
    SOH_SellerId: number = 0;
    SOH_ClientName: string = '';
    // children? : StockPicked[];
}

export class StockPickedGroup {
    orderId: number;
    quoteId: number;
    parentItems: StockPicked[];
    childItems: StockPicked[];
    dt: Date;
    expand: boolean;
}
export class StockPickedLead extends WIPLead {
    quoteLineId: number;
    stockPicked: number = 0;
    comments: string = '';

    constructor(data: Partial<StockPickedLead> = {}) {
        super(); // Call parent class constructor
        Object.assign(this, data);
        this.quoteLineId = data.quoteLineId || 0; // Ensure default value
        this.stockPicked = data.stockPicked || 0;
        this.comments = data.comments || '';
    }
}

export class StockPickedLeadSummary {
    quoteId: number;
    quoteLineId: number;
    quoteRef: string;
    msfid: number;
    qty: number;
    statusId: number;
    msfId: number;
    stockCode: string;
    description: string;
    brandImage: string;
    brand: string;
    qtyReserverd: number;
    qtyNotReserved: number;
    soh: number;
    availableSOH: number = 0;
    customerName: string = '';
    salesMan: string = '';
    vehicleReg: string = '';
    vehicleMake: string = '';
    vehicleModel: string = '';
    date: Date = new Date();
    comments: string = '';
}

export class StockPickedItem {
    orderId: number;
    orderLineId: number;
    quoteId: number;
    quoteLineId: number;
    msfId: number;
    qty: number;
    pickedQty: number = 0;
    stockPicked: number = 0;
    comments: string = '';
    userId: number = 0;
    isPickable: boolean = true;
    isTyre: boolean = false;
}

export class WIPUpdate {
    clientId: number; 
    userId: number; 
    quoteId: number; 
    quoteLineId: number; 
    stockPicked: number;
}
